import type { StoreItem } from './StoreLocator.types';
import * as Styled from './StoreLocator.styled';

interface StoreDropdownProps {
  stores: StoreItem[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
}

export const StoreDropdown = ({
  stores,
  selectedId,
  onSelect,
}: StoreDropdownProps) => (
  <Styled.Dropdown
    id="stores"
    name="stores"
    value={selectedId ?? ''}
    onChange={e => onSelect(e.target.value || null)}
  >
    <option value="">Select a store</option>
    {stores.map(store => (
      <option key={store.id} value={store.id}>
        {store.branchName}
      </option>
    ))}
  </Styled.Dropdown>
);
